export default __webpack_public_path__ + "fonts/montserrat400.woff";